import { PublicClientApplication, type Configuration } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID as string;
const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID as string;

const configuration: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // localStorage, not sessionStorage (the platform rule, Chauncey White
    // 2026-10-23 and 2026-11-02: every link lands signed in). A link opens a
    // NEW tab, and sessionStorage belongs to one tab — so every link arrived
    // with nobody signed in and asked again. With localStorage the new tab
    // finds the account and its refresh token and never redirects at all.
    // (It replaces the 2026-08-12 choice to end the session with the tab: the
    // Entra session cookie outlives the tab anyway, so closing the tab never
    // ended the sign-in — it only made the next tab ask again.) Every API call
    // is still checked by Entra and wise-iam. A shared PC is covered by the
    // link's ?login_hint beating whoever is cached (auth/ssoMemory.ts
    // linkAccount); the menu's Sign out clears this cache and the Entra session.
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(configuration);

/** The scope the API validates. Matches the Entra app's exposed scope. */
export const apiScopes = [`api://${clientId}/access_as_user`];

/** The sign-in request: the API scope. Every sign-in redirect adds only a loginHint. */
export const loginRequest = { scopes: apiScopes };
